import Calendar from 'react-calendar';
import './css/Calendar.css';

function CalendarioAsistencia({ fechasConAsistencia = [], fechasConAsistenciaGeneral = [], fechaSeleccionada, setFechaSeleccionada }) {

  const toDateLocal = (fecha) => {
    const [y, m, d] = fecha.split('-');
    return new Date(y, m - 1, d);
  };

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const fecha = date.toLocaleDateString('sv-SE');

      if (fechasConAsistencia && fechasConAsistencia.includes(fecha)) {
        return 'dia-con-asistencia';
      } else if (fechasConAsistenciaGeneral && fechasConAsistenciaGeneral.includes(fecha)) {
        return 'dia-con-asistencia-general';
      } else {
        return 'dia-sin-asistencia';
      }
    }
  };

  return (
    <div className="calendario-asistencia" style={{ width: '350px', margin: '0 auto' }}>
      <Calendar
        tileClassName={tileClassName}
        value={toDateLocal(fechaSeleccionada)}
        onChange={(date) => {
          const fecha = date.toLocaleDateString('sv-SE');
          setFechaSeleccionada(fecha);
        }}
      />
      <div className="d-flex justify-content-around mt-2 small text-muted">
        <div><i className="fa-solid fa-check-circle me-1" style={{ color: '#75b798' }}></i><span className="badge" style={{ backgroundColor: '#75b798' }}>&nbsp;&nbsp;</span> En esta materia</div>
        <div><i className="fa-solid fa-clipboard-user me-1 text-success"></i><span className="badge" style={{ backgroundColor: '#198754' }}>&nbsp;&nbsp;</span> En la escuela (Preceptor)</div>
      </div>
    </div>
  );
}

export default CalendarioAsistencia;